export function InviteNewMemberGuide() {
	return (
		<div className=" p-6 bg-card">
			<div className="space-y-6">
				{/* Step 1 */}
				<div>
					<h4 className="text-lg font-medium mb-2">
						1. Navigate to Invites Page
					</h4>
					<p className="text-sm text-muted-foreground">
						Click on <span className="font-semibold">"Invites"</span> in the
						side navigation menu to access the Invites page. This page displays
						all invitation codes you've created, including their status
						(accepted or pending) and expiration dates.
					</p>
				</div>

				{/* Step 2 */}
				<div>
					<h4 className="text-lg font-medium mb-2">
						2. Generate a New Invite Code
					</h4>
					<p className="text-sm text-muted-foreground mb-3">
						Click the <span className="font-semibold">"Create Invite"</span>{" "}
						button at the top of the page. The system will automatically
						generate a unique invite code and add it to the table below.
					</p>
					<p className="text-sm text-muted-foreground">
						Each invite code is valid for a limited time and can only be used
						once. Once a user successfully registers using the invite code, it
						will be marked as "Accepted" in the table.
					</p>
				</div>

				{/* Step 3 */}
				<div>
					<h4 className="text-lg font-medium mb-2">3. Copy the Invite Link</h4>
					<p className="text-sm text-muted-foreground mb-3">
						In the invites table, locate the invite code you just created. Next
						to each invite code, you'll see a{" "}
						<span className="font-semibold">copy button</span> (clipboard icon).
					</p>
					<p className="text-sm text-muted-foreground">
						Click the copy button to copy the full invite link to your
						clipboard. The link will be in the format:{" "}
						<code className="text-xs bg-muted px-1 py-0.5 rounded">
							https://ied-admin.ldlabs.diy/invite/[invite-code]
						</code>
					</p>
				</div>

				{/* Step 4 */}
				<div>
					<h4 className="text-lg font-medium mb-2">
						4. Send the Invite Link to the New Member
					</h4>
					<p className="text-sm text-muted-foreground mb-3">
						Share the copied invite link with the prospective member via email,
						text message, or your preferred communication method.
					</p>
					<div className="ml-4 space-y-2">
						<div>
							<p className="text-sm font-medium">Sample Email Template:</p>
							<div className="text-sm text-muted-foreground bg-muted p-3 rounded mt-2">
								<p className="mb-2">Subject: Join INDIVISIBLE El Dorado</p>
								<p className="mb-2">Hi [Name],</p>
								<p className="mb-2">
									We're excited to invite you to join INDIVISIBLE El Dorado!
									Please use the following link to complete your registration:
								</p>
								<p className="mb-2 font-mono text-xs break-all">
									[Paste the invite link here]
								</p>
								<p className="mb-2">
									This link will expire in [X days], so please register at your
									earliest convenience.
								</p>
								<p>Looking forward to having you as part of our community!</p>
							</div>
						</div>
					</div>
				</div>

				{/* Step 5 */}
				<div>
					<h4 className="text-lg font-medium mb-2">
						5. New Member Registration Process
					</h4>
					<p className="text-sm text-muted-foreground mb-3">
						When the new member clicks the invite link, they will be directed to
						a registration form where they'll need to provide:
					</p>
					<div className="ml-4 space-y-2">
						<ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
							<li>First Name</li>
							<li>Last Name</li>
							<li>Email Address</li>
							<li>Phone Number</li>
						</ul>
					</div>
					<p className="text-sm text-muted-foreground mt-3">
						After submitting the form, the new member will see a confirmation
						message and the invite code will be marked as "Accepted" in your
						invites table. The new member will appear in the{" "}
						<span className="font-semibold">Members</span> page.
					</p>
				</div>

				{/* Best Practices */}
				<div className="border-t pt-4">
					<h4 className="text-lg font-medium mb-2">Best Practices</h4>
					<ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground ml-2">
						<li>
							Generate invite codes only when you're ready to send them to avoid
							expired unused invites
						</li>
						<li>
							Include context in your invitation message about what INDIVISIBLE
							El Dorado is and why they're being invited
						</li>
						<li>
							Monitor the invites table to track which invitations have been
							accepted
						</li>
						<li>
							Follow up with invitees if they haven't registered before the
							invite expires
						</li>
						<li>
							Keep track of who you've sent invites to in case you need to
							generate a new code if one expires
						</li>
						<li>
							After a member registers, verify they appear in the Members page
							to confirm successful onboarding
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
